<template>
    <div class="w-full text-[var(--text)] gap-2 p-4 bg-[var(--fundoComponente)] rounded-[10px] bg-opacity-[0.55] flex flex-col">
        <div class="w-full flex justify-between">
            <h3 class="text-[var(--titulo)]">Encomenda</h3>
            <AppButton class=" self-end text-[var(--text)]" v-bind:visibility="true" left_icon="fa-regular fa-circle-xmark fa-xl" emitType="close"
                        @close="close" :width=23 :height=23 /> 
        </div>

        <div class="flex gap-2 w-full">
            <div class=" left-input-field flex flex-col gap-2">
                <div class=" flex gap-2">
                    <label class="min-w-[6rem]" for="fornecedor">Fornecedor:</label>
                    <input style="background-color: var(--label);" class="text-black text-[10px] border-1 border-[#ccc] p-1 rounded-[5px]" type="text" id="fornecedor" v-model="entities[0].nome" placeholder="fornecedor">
                </div>
                <div class=" flex gap-2">
                    <label class="min-w-[6rem]" for="numero">Orçamento:</label>
                    <input style="background-color: var(--label);" class="text-black text-[10px] border-1 border-[#ccc] p-1 rounded-[5px]" type="number" id="numero" v-model="entities[1].numero" placeholder="Orcamento">
                </div>
                <div class=" flex gap-2">
                    <label class="min-w-[6rem]" for="data">Recolha Entrega:</label>
                    <input style="background-color: var(--label);" class="text-black text-[10px] border-1 border-[#ccc] p-1 rounded-[5px]" type="text" id="data" v-model="model.recolha_entrega" placeholder="Recolha Entrega">
                </div>
                <div class=" flex gap-2">
                    <label class="min-w-[6rem]" for="data">Armazem Carga:</label>
                    <input style="background-color: var(--label);" class="text-black text-[10px] border-1 border-[#ccc] p-1 rounded-[5px]" type="text" id="data" v-model="model.armazem_carga" placeholder="Armazem Carga">
                </div>
                <div class=" flex gap-2">
                    <label class="min-w-[6rem]" for="data">Armazem Descarga:</label>
                    <input style="background-color: var(--label);" class="text-black text-[10px] border-1 border-[#ccc] p-1 rounded-[5px]" type="text" id="data" v-model="model.armazem_descarga" placeholder="Armazem Descarga">
                </div>
                <div class=" flex gap-2">
                    <label class="min-w-[6rem]" for="data">Data:</label>
                    <input style="background-color: var(--label);" class="text-black text-[10px] border-1 border-[#ccc] p-1 rounded-[5px]" type="text" id="data" v-model="model.data" placeholder="Data">
                </div>
                <div class=" flex gap-2">
                    <label class="min-w-[6rem]" for="data">Moeda:</label>
                    <select style="background-color: var(--label);" v-model="model.moeda_id" class="text-black text-[10px] border-1 border-[#ccc] p-1 rounded-[5px]" placeholder="Moeda">
                        <option v-for="option in moedas" :key="option.id" :value="option.id">{{ option.nome }}</option>
                    </select>            
                </div>

                <div class=" flex gap-2">
                    <label class="min-w-[6rem]" for="data">Iva:</label>
                    <select style="background-color: var(--label);" v-model="model.iva_id" class="text-black text-[10px] border-1 border-[#ccc] p-1 rounded-[5px]" placeholder="Iva">
                        <option v-for="option in ivas" :key="option.id" :value="option.id">{{ option.nome }}</option>
                    </select>            
                </div>

                <div class=" flex gap-2">
                    <label class="min-w-[6rem]" for="data">Prazo:</label>
                    <select style="background-color: var(--label);" v-model="model.prazo_id" class="text-black text-[10px] border-1 border-[#ccc] p-1 rounded-[5px]" placeholder="Prazo">
                        <option v-for="option in prazos" :key="option.id" :value="option.id">{{ option.nome }}</option>
                    </select>            
                </div>

                <div class=" flex gap-2">
                    <label class="min-w-[6rem]" for="data">Data Entrega:</label>
                    <input style="background-color: var(--label);" class="text-black text-[10px] border-1 border-[#ccc] p-1 rounded-[5px]" type="text" id="data" v-model="model.data_entrega" placeholder="Data Entrega">
                </div>
                <div class=" flex gap-2">
                    <label class="min-w-[6rem]" for="data">Fatura:</label>
                    <input style="background-color: var(--label);" class="text-black text-[10px] border-1 border-[#ccc] p-1 rounded-[5px]" type="number" id="data" v-model="model.fatura_id" placeholder="Fatura">
                </div>
                <div class=" flex gap-2">
                    <label class="min-w-[6rem]" for="data">Total:</label>
                    <input style="background-color: var(--label);" class="text-black text-[10px] border-1 border-[#ccc] p-1 rounded-[5px]" type="number" id="data" v-model="model.total" placeholder="Total">
                </div>
                <div class=" flex gap-2">
                    <label class="min-w-[6rem]" for="data">Status:</label>
                    <input style="background-color: var(--label);" class="text-black text-[10px] border-1 border-[#ccc] p-1 rounded-[5px]" type="text" id="data" v-model="model.status" placeholder="Status">
                </div>
            </div>

            <div class="right w-[40vw] flex flex-col gap-2 rounded-[10px] bg-[var(--fundoApp)] p-4 ">
                <h3 class="text-[var(--titulo)]">Item Encomenda</h3>
                <div class=" flex gap-2">
                    
                    <label class="min-w-[6.5rem]" for="data">Encomenda Id:</label>
                    <input style="background-color: var(--label);" class="text-black text-[10px] border-1 border-[#ccc] p-1 rounded-[5px]" type="number" id="data" v-model="item_encomenda_model.encomenda_id" placeholder="Encomenda Id">

                    <label class="min-w-[6.5rem]" for="data">Produto Id:</label>
                    <input style="background-color: var(--label);" class="text-black text-[10px] border-1 border-[#ccc] p-1 rounded-[5px]" type="number" id="data" v-model="item_encomenda_model.produto_id" placeholder="Produto Id">
                </div>

                <div class=" flex gap-2">
                    
                    <label class="min-w-[6.5rem]" for="data">Quantidade:</label>
                    <input style="background-color: var(--label);" class="text-black text-[10px] border-1 border-[#ccc] p-1 rounded-[5px]" type="number" id="data" v-model="item_encomenda_model.quantidade" placeholder="Quantidade">

                    <label class="min-w-[6.5rem]" for="data">Preço:</label>
                    <input style="background-color: var(--label);" class="text-black text-[10px] border-1 border-[#ccc] p-1 rounded-[5px]" type="number" id="data" v-model="item_encomenda_model.preco" placeholder="Preco">
                </div>

                <div class=" flex gap-2">
                    <label class="min-w-[6.5rem]" for="data">Status:</label>
                    <input style="background-color: var(--label);" class="text-black text-[10px] border-1 border-[#ccc] p-1 rounded-[5px]" type="number" id="data" v-model="item_encomenda_model.status" placeholder="Status">
                </div>

                <AppTable style="background-color: var(--titulo);" :visibility="true" :show="true" :table_data="produtos" table_title="Produtos"
                  @row-clicked="select_produto" @close="close_table" :show_multiSelect="false" />
                
            </div>

        </div>

    </div>

</template>


<script>
    import axios from 'axios';
    import AppButton from '@/components/button.vue'
    import AppTable from '@/components/tables/table.vue'
    export default {
        name: 'encomenda',
        components: {
            AppButton,
            AppTable
        },
        props: {
          entities: {
              type: Array,
              default: () => [
                {
                    nome: '',
                    id: 0
                },
                {
                    id: 0,
                    numero: '',
                }
              ]
            },  
        },
        data() {
            return {
                baseURl: process.env.VUE_APP_URL_BASE,
                model: {
                   recolha_entrega: '',
                   armazem_carga: '',
                   armazem_descarga: '',
                   data: '',
                   moeda_id: 0,
                   iva_id: 0,
                   prazo_id: 0,
                   data_entrega: '',
                   total: 0,
                   fatura_id: 0,
                   status: '',
                },
                item_encomenda_model:{
                    encomenda_id: 0,
                    produto_id: 0,
                    quantidade: 0,
                    preco: 0,
                    status: 0,
                },
                moedas:[],
                produtos:[],
                ivas: [],
                prazos: [],
                
            };
        },
        async created() {
            this.moedas= await this.select_all(`${this.baseURl}/api/v1/tpmoeda/`);
            this.produtos= await this.select_all(`${this.baseURl}/api/v1/produto/`);
            this.ivas= await this.select_all(`${this.baseURl}/api/v1/tpiva/`);
            this.prazos= await this.select_all(`${this.baseURl}/api/v1/tpprazo/`);
            
            
        },
        methods: {
            close() {
                this.$emit('close');
            },
            async create(data, url) {
              try {
                  const res = await axios.post(url, data);
                  return res.data.data;
              } catch (error) {
                  console.error('Error getting data:', error);
              }
            },
  
        async select(url) {
            try {
                const res = await axios.get(url);
                return res.data.data;
            } catch (error) {
                console.error('Error getting data:', error);
            }
        },
    
        async select_all(url) {
            try {
                const res = await axios.get(url);
                return res.data.data;
    
            } catch (error) {
                console.error('Error getting data:', error);
            }
    
        },
    
        async update(url, data) {
    
            try {
                const res = await axios.put(url, data);
                console.log('Data successfully updated:', res.data);
                return res.data.data;
    
            } catch (error) {
                console.error('Error posting data:', error);
            }
        },
    
        async remove(url) {
            // console.log("Data:", data.id)
            try {
                await axios.delete(url);
                return true;
            } catch (error) {
                console.error('Error deleting data:', error);
            }
        },
            
        }
    }

</script>



<style scoped>


</style>